import script from "./mainWarp.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainWarp.vue?vue&type=script&setup=true&lang=ts"

import "./mainWarp.vue?vue&type=style&index=0&id=06ad3e0b&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ad3e0b"]])

export default __exports__